<template>
    <VJoyHighlight>
        <VJoyWrapper align="center" column-gap="2" direction="row" justify="flex-start" no-margin wrap="nowrap">
            <VJoyIcon color="secondary" name="eye-masked" />
            <VJoyText>{{ t('profile.hidden.appraisals.by.client.count', {count: hiddenCounter}) }}</VJoyText>
        </VJoyWrapper>
    </VJoyHighlight>
</template>

<script lang="ts" setup>
    import {useTranslation} from '#imports';
    import {VJoyHighlight, VJoyIcon, VJoyText, VJoyWrapper} from '@maltjoy/core-vue';

    defineProps<{
        hiddenCounter: number;
    }>();
    const {t} = useTranslation();
</script>
